module.exports = __webpack_public_path__ + "img/Atelier_Hintergrund.0d4a83eb.jpg";